import { Box, Typography } from '@mui/material';

export interface NoResultsOverrideType {
  mainText?: string;
  subText?: string;
}

export function NoResultsText({
  textOverride,
}: {
  textOverride?: NoResultsOverrideType;
}) {
  return (
    <Box sx={{ py: 2, w: 1, textAlign: 'center' }}>
      <Typography variant="overline" align="center" fontSize="1.1rem">
        {textOverride?.mainText || 'No Results'}
      </Typography>
      <Typography variant="subtitle2" align="center" fontSize={'0.8rem'}>
        {textOverride?.subText !== undefined
          ? textOverride.subText
          : 'Try adjusting your filters'}
      </Typography>
    </Box>
  );
}
